import { Middleware } from '@reduxjs/toolkit';
import i18n from 'i18next';

import {
  initiateNewTransaction,
  onInputBlur,
  selectAmount,
  selectPaymentMethod,
  setPaymentResult,
} from '@cashier/cashier-data-access';
import { FinalStates, ResultMessage } from '@cashier/cashier-model';
import { eventBus, EventFactory } from '@cashier/cashier-shared';

import { AMOUNT_FIELD_NAME, FIAT_AMOUNT } from '../constants';
import { getAmountValidationErrors } from '../helpers';

export const parentNotificationMiddleware: Middleware =
  (store) => (next) => (action) => {
    const {
      cashierConfiguration: { notifyCustomerAboutPaymentResult },
      paymentResult: { finalState },
      customerInformation: { amount },
      paymentProcessing: { error },
    } = store.getState();

    const result = next(action);
    if (
      action.type === setPaymentResult.toString() &&
      notifyCustomerAboutPaymentResult
    ) {
      const paymentResult: {
        finalState: FinalStates;
        message: ResultMessage;
      } = action.payload;

      //@TODO: Crutch for pending state
      const message =
        FinalStates.PENDING === paymentResult.finalState
          ? paymentResult.message
            ? `${i18n.t('finalScreenPending.text1')} ${paymentResult.message.content}`
            : i18n.t('finalScreenPending.text1')
          : paymentResult.message.content;

      eventBus.emit(
        EventFactory.cashierClosed(paymentResult.finalState, message),
      );
    }

    if (action.type === initiateNewTransaction.toString()) {
      if (FinalStates.ERROR === finalState) {
        eventBus.emit(
          EventFactory.paymentRetried(amount, error?.transactionId),
        );
      } else {
        eventBus.emit(EventFactory.newPaymentInitiated());
      }
    }

    if (action.type === onInputBlur.toString()) {
      const { fieldName } = action.payload;
      const {
        paymentForm: { paymentInputs },
      } = store.getState();
      const field = paymentInputs[fieldName];

      if (fieldName === AMOUNT_FIELD_NAME || fieldName === FIAT_AMOUNT) {
        const method = selectPaymentMethod(store.getState());
        const amount = selectAmount(store.getState());

        const amountValidationErrors = getAmountValidationErrors({
          method,
          amount,
        });

        if (amountValidationErrors.length || !field.isValid) {
          eventBus.emit(
            EventFactory.onValidationFailed(
              fieldName,
              amountValidationErrors.join('. '),
            ),
          );
        }
      } else if (field && !field.isValid) {
        eventBus.emit(
          EventFactory.onValidationFailed(fieldName, field.errorMsg),
        );
      }
    }

    return result;
  };
